// Spreads exact-duplicate coordinates into a small circle so every marker
// stays clickable. Radius is in screen pixels, converted to degrees via the
// current zoom, so the on-screen gap stays constant at any zoom level.
const OVERLAP_SPREAD_PIXELS = 12

export function spreadOverlappingMarkers<
	T extends { lat: number; lng: number },
>(markers: T[], zoom: number): T[] {
	const groups = new Map<string, T[]>()
	markers.forEach((marker) => {
		const key = `${marker.lat.toFixed(6)},${marker.lng.toFixed(6)}`
		if (!groups.has(key)) groups.set(key, [])
		groups.get(key)!.push(marker)
	})

	return Array.from(groups.values()).flatMap((group) => {
		if (group.length === 1) return group

		const metersPerPixel =
			(156543.03392 * Math.cos((group[0].lat * Math.PI) / 180)) /
			Math.pow(2, zoom)
		const spreadMeters = OVERLAP_SPREAD_PIXELS * metersPerPixel
		const metersPerDegLat = 111320
		const metersPerDegLng = 111320 * Math.cos((group[0].lat * Math.PI) / 180)

		return group.map((marker, index) => {
			const angle = (2 * Math.PI * index) / group.length
			return {
				...marker,
				lat: marker.lat + (spreadMeters * Math.sin(angle)) / metersPerDegLat,
				lng: marker.lng + (spreadMeters * Math.cos(angle)) / metersPerDegLng,
			}
		})
	})
}
